'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var appTypes = require('../../types/appTypes');
var util = require('../../helper/util');
var textHelper = util.Text;
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

var BarItem = React.createClass({
  render: function () {
    return (
      <div className="BarItem"
           style={this.mainCSS()}
           onClick={this.onSelClick}>
        <div ref="text" className="item-text">
          <label>
            {this.props.text}
          </label>
        </div>
        <canvas ref="canvas" style={{position:'absolute',zIndex:0,width:'100%',height:'100%'}}/>
      </div>
    );
  },

  paint : function(){
    var self = this;
    this.requestID = window.requestAnimationFrame(function(){
      var canvas = ReactDOM.findDOMNode(self.refs.canvas);
      var g = canvas.getContext('2d');
      var w = canvas.clientWidth;
      var h = canvas.clientHeight;
      var thickness = 1;
      var offset = thickness/2;
      canvas.width = w;
      canvas.height = h;
      g.clearRect(0,0,w,h);
      g.lineWidth = thickness;
      g.strokeStyle = '#000';
      //g.strokeWidth = thickness;
      g.fillStyle = self.props.backgroundColor;
      if(self.props.direction === appTypes.VerticalDirection.TOP){
        g.moveTo(offset,h);
        g.lineTo(offset,offset);
        g.lineTo(w - 20,offset);
        g.lineTo(w,h + thickness);
      }else{
        g.moveTo(offset,0);
        g.lineTo(offset,h - offset);
        g.lineTo(w - 20,h - offset);
        g.lineTo(w,0);
      }
      g.fill();
      g.stroke();
    });
  },

  mainCSS : function(){
    var css =  {
      overflow : 'hidden',
      position : 'absolute',
      width : this.props.width,
      height : this.props.height,
      zIndex : this.props.zIndex,
      borderStyle : 'none',
      boxSizing : 'border-box',
      borderWidth : 1,
      textDecoration : 'inherit'
    };
    if(this.props.direction === appTypes.VerticalDirection.TOP){
      css.borderBottom = this.props.selected ? ('1px solid ' + this.props.backgroundColor) : '1px solid #444';
    }else{
      css.borderTop = this.props.selected ? ('1px solid ' + this.props.backgroundColor) : '1px solid #444';
    }
    return css;
  },


  onSelClick: function (e) {
    if (this.props.onClick) {
      this.props.onClick(e,this.props.index);
    }
  },

  componentWillUnmount : function(){
    if(this.requestID){
      window.cancelAnimationFrame(this.requestID);
    }
  },

  componentDidMount: function () {
    this.adjust();
    this.paint();
  },

  componentDidUpdate : function(){
    this.paint();
  },

  adjust: function () {
    var txtDom = ReactDOM.findDOMNode(this.refs.text);
    var leftDom = ReactDOM.findDOMNode(this.refs.left);
    var bevelBorderDom = ReactDOM.findDOMNode(this.refs.bevelBorder);
    var bevelFillDom = ReactDOM.findDOMNode(this.refs.bevelFill);
    var selfDom = ReactDOM.findDOMNode(this);
    var txtWidth = txtDom.clientWidth;
    var h = selfDom.clientHeight;
    var offset = 1;
    if(h > 25){
      offset = (h-25)/150;
    }
    var width = txtWidth + 32;
    $(selfDom).css({width: width});
    $(leftDom).css({width: width - 20});
    $(bevelBorderDom).css({left: width - 20});
    $(bevelFillDom).css({left: width - 20 - offset});
    $(txtDom).css({lineHeight: this.props.height + 'px', paddingLeft: 10})
  }
});

/***
 * 水平选项卡面板
 * @orthor mengxiaojiang
 * @createData 2016-6-15
 */
var HorizontalTabBar = React.createClass({

  getInitialState: function () {
    return {
      selectedIndex: util.Int(this.props.selectedIndex)
    }
  },

  render: function () {
    var txtStr;
    var tabHeight = styleHelper.getInt(this.props,propConst.TAB_HEIGHT);
    var selIndex = this.state.selectedIndex;
    var showScrollBar = false;
    var value = 0;
    var txtColor = styleHelper.getTextColor(this.props);
    var h = styleHelper.getHeight(this.props);
    var bgColor = styleHelper.getBackgroundColor(this.props);
    if (!_.isUndefined(this.props.verticalScrollbarShow)) {
      showScrollBar = this.props.verticalScrollbarShow;
      value = util.Int(this.props.verticalScrollbarProgress);
    }
    if (this.props.text) {
      txtStr = textHelper.delimitText(styleHelper.getText(this.props),textHelper.DM_COMMA);
    }
    return (
      <div className="component component-HorizontalTabBar">
        <div ref="bar" className="bar"
             style={{
              height : tabHeight + 1,
              fontStyle : this.props.textStyles.fontStyle,
              fontSize : this.props.textSize,
              fontWeight : this.props.textStyles.fontWeight,
              textDecoration : this.props.textStyles.textDecoration,
              fontFamily : this.props.textFontFamily,
              color : txtColor
            }}>
          {
            txtStr.map(function (itm, index) {
              return (<BarItem key={index} {...{
                width: 'auto',
                height: tabHeight,
                backgroundColor: index === selIndex ? bgColor : '#ddd',
                text: itm,
                index: index,
                selected: index === selIndex,
                zIndex: index === selIndex ? (txtStr.length + 10) : (txtStr.length - index),
                onClick: this.onItemClick,
                direction : this.props.direction
              }}/>)
            }, this)
          }
        </div>
        <div ref="content" style={{
          position : 'absolute',
          zIndex : 1,
          width : '100%',
          height : h - tabHeight + 1,
          top :tabHeight - 1,
          borderLeftStyle:this.props.borderVisible?'solid':'none',
          borderRightStyle:this.props.borderVisible?'solid':'none',
          borderTopStyle:this.props.borderVisible?'solid':(this.props.direction === appTypes.VerticalDirection.TOP?'solid':'none'),
          borderBottomStyle:this.props.borderVisible?'solid':(this.props.direction === appTypes.VerticalDirection.BOTTOM?'solid':'none'),
          borderWidth : 1,
          backgroundColor :bgColor
        }}>

          {
            showScrollBar && (
              <VerticalScrollBar {...{value : value,right : -1,top : -1,height : h - tabHeight}}/>
            )
          }

        </div>
      </div>);
  },

  onItemClick: function (e,index) {
    this.setState({selectedIndex: index})
  },

  componentDidMount: function () {
    this.adjust();
    $(ReactDOM.findDOMNode(this)).bind('itemClick',this.onItemClick);
  },

  adjust: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var bar = ReactDOM.findDOMNode(this.refs.bar);
    var tabH = styleHelper.getInt(this.props,propConst.TAB_HEIGHT);
    var content = ReactDOM.findDOMNode(this.refs.content);
    var barItems = bar.children;
    var itemDom;
    var i;
    var left = 20;
    var itemWidth;
    var display = 'visible';
    var tabPosition = styleHelper.getPropertyValue(this.props,propConst.TAB_POSITION);
    var barWidth = 0;
    for (i = 0; i < barItems.length; i++) {
      itemDom = barItems[i];
      itemWidth = itemDom.clientWidth;
      barWidth += (itemWidth - 15);
    }
    if(barWidth){
      barWidth += 15;
    }
    if(tabPosition === appTypes.HoriAlign.CENTER){
      left = (w - barWidth)/2;
    }else if(tabPosition === appTypes.HoriAlign.RIGHT){
      left = w - barWidth - 20;
    }
    for (i = 0; i < barItems.length; i++) {
      itemDom = barItems[i];
      itemWidth = itemDom.clientWidth;

      display = 'visible';
      if(left < 0){
        display = 'hidden';
      }
      if(left + itemWidth > w){
        display = 'hidden';
      }
      $(itemDom).css({left: left,visibility:display});
      left += itemDom.clientWidth - 15;
    }
    if(this.props.direction === appTypes.VerticalDirection.TOP){
      $(bar).css({top : 0});
      $(content).css({top : tabH - 1});
    }else{
      $(bar).css({top : h - tabH + 2});
      $(content).css({top : 0});
    }

  }
});

module.exports = HorizontalTabBar;



/** WEBPACK FOOTER **
 ** ./src/views/Components/HorizontalTabBar.jsx
 **/